import SparkleDivider from './SparkleDivider'

export type { SparkleDividerProps } from './SparkleDivider'

export default SparkleDivider
